<app-pay-button *ngIf="english"></app-pay-button>
<app-pay-button-hindi *ngIf="hindi"></app-pay-button-hindi>